import Reflux from 'reflux';
import SidebarAction from '../action/sidebarAction';

export default Reflux.createStore({
  listenables: SidebarAction,
  onPublishAllWidget: function(data) {
    this.trigger(data);
  },
});



/** WEBPACK FOOTER **
 ** ./assets/src/frontend/preview/store/sidebarStore.js
 **/